import React from 'react'
import { Container, Flex } from 'pcln-design-system'
import LayoutComponentWrapper from './LayoutComponentWrapper'

export default function AdBanner({
  children
}: {
  children?: React.ReactNode | React.ReactNode[]
}) {
  return (
    <LayoutComponentWrapper>
      <Flex alignItems="center" justifyContent="center">
        <Container maxWidth={728}>{children}</Container>
      </Flex>
    </LayoutComponentWrapper>
  )
}
